<div class="trivia">
  <div class="top">
    <p class="typography-title">
      {{ triviaRain().question }}
    </p>
    <countdown
      #cd
      class="countdown"
      [config]="{ leftTime: triviaRain().timeleft, format: 'mm:ss' }"
      (event)="countDownEvent($event)"
    />
  </div>
  <div class="options">
    @for (question of options(); track $index) {
    <div
      class="option"
      [class.selected]="hash() === question.hash"
      [class.disabled]="hash()"
      (click)="handleChoiceRainTrivia(question.hash)"
    >
      <span #text>{{ question.text }}</span>
      @let hasEllipsis = text.scrollWidth > text.clientWidth ||
      text.scrollHeight > text.clientHeight;
      <!--  -->
      @if (hasEllipsis) {
      <button
        class="s-24"
        type="button"
        [ngpTooltipTrigger]="tooltipMuteDetails"
        [ngpTooltipTriggerHideDelay]="0"
        [ngpTooltipTriggerOffset]="10"
      >
        <svg-icon src="assets/icons/shared/info.svg"></svg-icon>
      </button>
      <ng-template #tooltipMuteDetails>
        <div ngpTooltip class="tooltip">
          {{ question.text }}
        </div>
      </ng-template>
      }
    </div>
    }
  </div>
  <div class="extra">
    <app-cost [cost]="triviaRain().amount" balanceType="skins" />
    <app-player-row
      (click)="contextMenuService.open($event, { user: user() })"
      [player]="user()"
    />
  </div>
</div>
